import React from 'react';
import classNames from 'classnames';

const TableLayout = ({ title, description, button, children }) => {
	return (
		<>
			<div className="flex flex-col sm:grid grid-cols-[2fr_1fr] mb-8 sm:mb-12">
				{title && (
					<h1 className={classNames(
						'h1 col-start-1 col-end-2',
						description ? 'mb-4' : 'mb-0',
					)}>
						{title}
					</h1>
				)}
				{description && (
					<div className="text-[#A5A5A5] col-start-1 col-end-2">{description}</div>
				)}
				{button && (
					<div className="flex justify-end mt-8 sm:mt-0 col-start-2 row-start-1">
						{button}
					</div>
				)}
			</div>
			{children}
		</>
	)
}

export default TableLayout;
